module.exports = __webpack_public_path__ + "static/media/04.b725f8ba.jpg";